export var USD = "USD";
export var EUR = "EUR";
export var GBP = "GBP";
export var AUD = "AUD";
export var CHF = "CHF";
export var JPY = "JPY";
export var NZD = "NZD";
export var CAD = "CAD";
export var HKD = "HKD";
export var CNY = "CNY";
export var KRW = "KRW";
export var SGD = "SGD";
export var IDR = "IDR";
export var MYR = "MYR";
export var PHP = "PHP";
export var THB = "THB";
export var VND = "VND";
export var KHR = "KHR";
export var INR = "INR";
export var ALL = "ALL";
export var CNH = "CNH";
export var SEK = "SEK";
export var NPR = "NPR";
export var DKK = "DKK";
export var BDT = "BDT";
export var BND = "BND";

export var SOURCE_CURRENCY_SUPPORTED = [
    SGD, AUD, EUR, USD, GBP, MYR, HKD, CNY, CAD, IDR, THB
]
export var ALL_SOURCE_CURRENCY_SUPPORTED = [
    ALL, SGD, AUD, EUR, USD, GBP, MYR, HKD, CNY, CAD, IDR, THB
]
export var TARGET_CURRENCY_SUPPORTED = [
    USD, EUR, GBP, AUD, CHF, JPY, NZD, CAD, HKD, CNY, KRW, SGD, IDR, MYR, PHP, THB, VND, KHR, SEK, NPR, DKK, CNH, BDT, INR, BND
]
export var ALL_TARGET_CURRENCY_SUPPORTED = [
    ALL, USD, EUR, GBP, AUD, CHF, JPY, NZD, CAD, HKD, CNY, KRW, SGD, IDR, MYR, PHP, THB, VND, KHR, SEK, NPR, DKK, CNH, BDT, BND
]

export var ALL_ORDER_STATUS_SUPPORTED   = ['ALL', 'COMPLIANCE', 'PENDING_APPROVAL','BOOKING', 'RECEIVED', 'SENT',  'COMPLETED', 'CANCELED','DRAFT_COMPLIANCE','PREBOOKING'];
